export default __webpack_public_path__ + "static/column-with-negative-values-6b370bad377f885212fc46311abb2125.png";